export default "__VITE_ASSET__0_34LSyi__"